function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
      this.closest('header')?.classList.add('menu-open');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    this.closest('header')?.classList.remove('menu-open');
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
      this.closest('header')?.classList.add('menu-open');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
    
    // Autoplay videos in active sizing guide tab content
    const activeTabContent = this.querySelector('.sizing-guide__tab-content.active');
    if (activeTabContent) {
      const videos = activeTabContent.querySelectorAll('video');
      videos.forEach(video => {
        video.play().catch(err => console.log('Video autoplay failed:', err));
      });
    }
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.productForm = this.closest('.product__info-container');
    this.submitButton = this.productForm.querySelector('[type="submit"]');
    // this.notifyButton = this.productForm.querySelector('.klaviyo-bis-trigger');
  }

  connectedCallback() {
    // Update low stock text on initial load
    setTimeout(() => {
      this.updateVariantLowStockText();
    }, 100);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updatePickupAvailability();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateVariantLowStockText();
      this.updateButtonsVisibility(this.currentVariant.available);
    }
  }

  updateButtonsVisibility(isAvailable) {
    // Update submit button
    if (this.submitButton) {
      this.submitButton.style.display = isAvailable ? 'flex' : 'none';
      this.submitButton.disabled = !isAvailable;
    }

    // Update notify button
    // if (this.notifyButton) {
    //   this.notifyButton.classList.toggle('hidden', isAvailable);
    // }

    // Dispatch event for product-form
    if (this.productForm) {
      this.productForm.dispatchEvent(
        new CustomEvent('variant:changed', {
          detail: {
            variant: this.currentVariant,
            available: isAvailable
          }
        })
      );
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));

      const eventCustom = new CustomEvent('variantChange', {});
      document.dispatchEvent(eventCustom);
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });

        const eventCustom = new CustomEvent('variantChangeProductInfo', {});
        document.dispatchEvent(eventCustom);

        // Update low stock text for variant options with a small delay to ensure price is updated
        setTimeout(() => {
          this.updateVariantLowStockText();
        }, 50);
      });
  }

  updateVariantLowStockText() {
    // Get the low stock badge from the price component in the same section
    const priceElement = document.getElementById(`price-${this.dataset.section}`);
    const lowStockBadge = priceElement ? priceElement.querySelector('.price__badge--low-stock .hidden-infos') : null;
    const lowStockElements = this.querySelectorAll('[data-variant-low-stock]');
    if (priceElement.querySelector('.price')?.classList.contains('price--low-stock') && lowStockBadge && lowStockElements.length > 0) {

        // Get the inner HTML from the low stock badge
        const lowStockText = lowStockBadge.innerHTML;
        
        // Update all variant low stock text elements
        lowStockElements.forEach(element => {
          element.innerHTML = lowStockText;
          element.style.display = 'inline';
        });
    } else {
      // Hide all low stock elements if no low stock badge is present
      lowStockElements.forEach(element => {
        element.style.display = 'none';
      });
    }
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class TabsComponent extends HTMLElement {
  constructor() {
    super();
    this.buttons = Array.from(this.querySelectorAll('[data-tab="button"]'));
    this.contents = Array.from(
      this.querySelectorAll('[data-tab="content"]')
    );

    if (
      this.buttons.length == 0 ||
      this.contents.length == 0 ||
      this.buttons.length != this.contents.length
    )
      return;

    this.activateTab(0);

    // Attach click event listeners to each tab
    this.buttons.forEach((tab, index) => {
      tab.addEventListener("click", () => {
        this.activateTab(index);
      });
    });
  }

  activateTab(index) {
    if (this.activeTab != null) {
      this.buttons[this.activeTab].classList.remove("active");
      this.contents[this.activeTab].classList.remove("active");
      
      // Pause videos in previously active tab
      const previousVideos = this.contents[this.activeTab].querySelectorAll('video');
      previousVideos.forEach(video => video.pause());
    }

    this.buttons[index].classList.add("active");
    this.contents[index].classList.add("active");
    this.activeTab = index;
    
    // Autoplay videos in newly active tab
    const activeVideos = this.contents[index].querySelectorAll('video');
    activeVideos.forEach(video => {
      video.play().catch(err => console.log('Video autoplay failed:', err));
    });
  }
}

customElements.define("tabs-component", TabsComponent);

class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.daysContainer = this.querySelector('[data-timer="days"]');
    this.hoursContainer = this.querySelector('[data-timer="hours"]');
    this.minutesContainer = this.querySelector('[data-timer="minutes"]');
    this.secondsContainer = this.querySelector('[data-timer="seconds"]');

    this.endDate = this.dataset.timerEndDate;
    this.endTime = this.dataset.timerEndTime;
    this.endDateAndTime = Date.parse(`${this.endDate} ${this.endTime}-04:00`);

    this.countdown = setInterval(this.updateTimer.bind(this), 1000);
  }

  updateTimer() {
    this.now = new Date().getTime();
    this.diff = this.endDateAndTime - this.now;

    this.days = Math.floor(this.diff / (1000 * 60 * 60 * 24));
    this.hours = Math.floor(this.diff / (1000 * 60 * 60));
    this.mins = Math.floor(this.diff / (1000 * 60));
    this.secs = Math.floor(this.diff / 1000);

    this.updateView();

    if (this.diff < 0) {
      clearInterval(this.countdown);
      this.style.display = "none";
      // location.reload();
    }
  }

  updateView() {
    if (this.daysContainer != null) {
      this.daysContainer.innerText = this.days;
    }

    if (this.hoursContainer != null) {
      this.hoursContainer.innerText = String(
        this.hours - this.days * 24
      ).padStart(2, "0");
    }

    if (this.minutesContainer != null) {
      this.minutesContainer.innerText = String(
        this.mins - this.hours * 60
      ).padStart(2, "0");
    }

    if (this.secondsContainer != null) {
      this.secondsContainer.innerText = String(
        this.secs - this.mins * 60
      ).padStart(2, "0");
    }
  }
}

customElements.define("countdown-timer", CountdownTimer);

// All of these components have been moved to Global.js
class SFLCartMessage extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.classList.add("cart-with-sfl__message");
    setTimeout(this.show.bind(this), 100);
  }

  show() {
    this.classList.add("show");
    setTimeout(this.hide.bind(this), 3000);
  }

  hide() {
    this.classList.remove("show");
    setTimeout(
      function () {
        this.remove();
      }.bind(this),
      400
    );
  }
}

customElements.define("sfl-cart-message", SFLCartMessage);

class AddToSFLButton extends HTMLElement {
  constructor() {
    super();
    /* 
      du = Canonical URL of the product being added.
      empi = Variant ID of the product being added.
      epi = Product ID of the product being added. 
    */

    this.products = [
      {
        du: this.dataset.du,
        empi: this.dataset.empi,
        epi: this.dataset.epi,
      },
    ];

    this.addButton = this.querySelector('[data-btn-type="add"]');
    this.addButton.addEventListener("click", this.addToSFL.bind(this));
    this.SFLWrapper = this.closest("sfl-wrapper");
    // this.cartSFL = this.SFLWrapper.querySelector("cart-sfl");
  }

  addToSFL(event) {
    event.preventDefault();

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(this.swymCallback.bind(this));
  }

  onError(error) {
    // Error is an xhrObject
    // TO DO : ADD MESSAGE {% endcomment %}
    console.log("[SFL] Error: ", error);
  }

  onSuccess(response) {
    let message;
    if (response.itemsadded.length > 0) {
      message = `<div><span class="underline">${response.itemsadded[0].dt}</span> was added to <span class="underline">save for later</span></div>`;
    } else if (response.itemsfailed.length > 0) {
      message = `<div>There was an error adding <span class="underline">${response.itemsdeleted[0].dt}</span> to <span class="underline">save for later</span></div>`;
    }

    // We don't have the cart installed.
    // this.SFLWrapper.showMessage(message, "cart");
    // No need to dispatch an event to render SFL components since it will be dispatched once item is removed from Cart.
    this.removeFromCart();
  }

  swymCallback(swat) {
    swat.SaveForLater.add(
      localStorage.getItem("SFLListID"),
      this.products,
      this.onSuccess.bind(this),
      this.onError
    );
  }

  removeFromCart() {
    const cartItems =
      this.closest("cart-items") || this.closest("cart-drawer-items");
    cartItems.updateQuantity(this.dataset.index, 0);
  }
}

customElements.define("add-to-sfl-button", AddToSFLButton);

class RemoveFromSFLButton extends HTMLElement {
  constructor() {
    super();

    /* 
      du = Canonical URL of the product being added.
      empi = Variant ID of the product being added.
      epi = Product ID of the product being added. 
    */

    this.products = [
      {
        du: this.dataset.du,
        empi: this.dataset.empi,
        epi: this.dataset.epi,
      },
    ];

    this.SFLWrapper = this.closest("sfl-wrapper");
    this.SFLList = this.closest("cart-sfl") || this.closest("page-sfl");
    this.removeButton = this.querySelector("button");

    if (this.removeButton == null) return;
    this.removeButton.addEventListener("click", this.removeFromSFL.bind(this));
  }

  removeFromSFL(event) {
    if (event != null) event.preventDefault();

    // _swat.SaveForLater.remove(localStorage.getItem('SFLListID'), this.products, this.onSuccess.bind(this), this.onError); {% endcomment %}

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(this.swymCallback.bind(this));
  }

  onError(error) {
    // Error is an xhrObject
    console.log("[SFL] Error: ", error);
  }

  onSuccess(response) {
    let message;
    console.log('[SFL] Response: ', response);
    if (response.itemsdeleted.length > 0) {
      message = `<div><span class="underline">${response.itemsdeleted[0].dt}</span> was removed from <span class="underline">save for later</span></div>`;
    } else if (response.itemsfailed.lenght > 0) {
      message = `<div>There was an error adding <span class="underline">${response.itemsfailed[0].dt}</span> to <span class="underline">save for later</span></div>`;
    }

    // We don't have the cart installed.
    // this.SFLWrapper.showMessage(
    //   message,
    //   "sfl"
    // );

    // this.SFLList.renderSFL();
    const event = new CustomEvent("wishlist:render-sfl");
    document.dispatchEvent(event);
  }

  swymCallback(swat) {
    swat.SaveForLater.remove(
      localStorage.getItem("SFLListID"),
      this.products,
      this.onSuccess.bind(this),
      this.onError
    );
  }
}

customElements.define("remove-from-sfl-button", RemoveFromSFLButton);

const PageSFLTemplate = document.createElement("template");

class CartSFL extends HTMLElement {
  constructor() {
    super();
    this.SFLWrappers = document.querySelectorAll("sfl-wrapper");
    this.closestSFLWrapper = this.closest("sfl-wrapper");
    // this.hasRendered = false;

    this.targetToRender = this.querySelector("[data-render-sfl]");

    this.createSFLCard = this.createSFLCard.bind(this);
    this.renderSFL = this.renderSFL.bind(this);

    document.addEventListener(
      "wishlist:render-sfl",
      function () {
        console.log("[SFL] Rendering through Event: ", this);
        this.fetchSFL();
      }.bind(this)
    );
  }

  connectedCallback() {
    this.style.display = "block";
  }

  fetchSFL() {
    console.log("[SFL] Fetching...");

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(this.swymCallback.bind(this));
  }

  swymCallback(swat) {
    swat.SaveForLater.fetch(
      localStorage.getItem("SFLListID"),
      this.onFetchSuccess.bind(this),
      this.onError
    );
  }

  onError(error) {
    // Error is an xhrObject
    console.log("[SFL] Error: ", error);
  }

  onFetchSuccess(response) {
    console.log("[SFL] Fetch successful response: ", response);

    this.renderSFL(response.items);
  }

  getCardTemplateToRender() {
    const template = document.createElement("template");
    template.innerHTML = `
      <tr class="cart-item" role="row" data-sfl-card>
        <td class="cart-item__media" role="cell" headers="CartDrawer-ColumnProductImage">
          <a href="" class="cart-item__link" tabindex="-1" aria-hidden="true"> </a>
          <img class="cart-item__image" src="" alt="" loading="lazy" width="150" height="150">
        </td>
        <td class="cart-item__details" role="cell" headers="CartDrawer-ColumnProduct">
          <a href="" class="cart-item__name h4 break" data-product-title></a>
        </td>
        <td class="cart-item__totals right" role="cell" headers="CartDrawer-ColumnTotal">
          <div class="cart-item__price-wrapper">
            <span class="price price--end">
              <span data-product-currency class="currency-symbol"></span><span data-product-price></span>
            </span> 
          </div>
        </td>
        <td class="cart-item__quantity" role="cell" headers="CartDrawer-ColumnQuantity">
          <div class="cart-item__quantity-wrapper">
            <product-form>
              <form method="post" action="/cart/add" id="" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                <input type="hidden" name="form_type" value="product">
                <input type="hidden" name="utf8" value="✓">
                <input type="hidden" name="id">
                <button 
                  id="" 
                  type="submit" 
                  name="add"
                  class="sfl-add-to-cart-button button button--full-width button--secondary"
                >
                  <span data-sfl-add-to-cart-submit-text>Add to cart</span>
                  <span class="sold-out-message hidden">
                    Sold out
                  </span>
                  <div class="loading__spinner hidden">
                    <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                      <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                    </svg>
                  </div>
                </button>
              </form>
            </product-form>
            <remove-from-sfl-button id="CartDrawer-Remove-1">
              <button class="button button--tertiary" aria-label="">
                REMOVE
              </button>
            </remove-from-sfl-button>
          </div>
        </td>
      </tr>
      `;
    return template;
  }

  renderSFL(items) {
    console.log("[SFL] this: ", this);

    console.log('[SFL] Items: ', items)
    let fragment = document.createDocumentFragment();
    for (const item of items) {
      let card = this.createSFLCard(item);
      fragment.appendChild(card);
    }

    if (this.targetToRender != null) {
      this.targetToRender.innerHTML = "";
      this.targetToRender.appendChild(fragment);
      console.log("[SFL] Rendered into: ", this.targetToRender);
    } else {
      console.log("[SFL] There are no container to render SFL cards.");
    }
  }

  createSFLCard(product) {
    const card = this.getCardTemplateToRender().content.cloneNode(true);
    const title = card.querySelector("[data-product-title]");
    const image = card.querySelector("img");
    const links = card.querySelectorAll("a");
    const price = card.querySelector("[data-product-price]");
    const currency = card.querySelector("[data-product-currency]");
    const removeButton = card.querySelector("remove-from-sfl-button");
    const variantIdInput = card.querySelector('product-form input[name="id"]');
    const addToCartButton = card.querySelector("product-form button");
    const addToCartButtonText = addToCartButton.querySelector(
      "[data-sfl-add-to-cart-submit-text]"
    );

    title.textContent = product.dt;

    image.src = product.iu;
    image.alt = product.dt;

    links.forEach((link) => {
      link.href = product.du;
      link.ariaLabel = product.dt;
    });

    price.textContent = product.pr;

    if (Shopify.currency.active != null && currency != null) {
      // TO DO: Add to the curencyMap all the current currencies. {% endcomment %}
      const currencyMap = {
        CAD: "$",
        USD: "$",
        AUD: "$",
        BRL: "R$",
        EUR: "€",
        HKD: "$",
        ILS: "₪",
        JPY: "¥",
        MXN: "$",
        NZD: "$",
        NOK: "kr",
        SGD: "$",
        KRW: "₩",
        GBP: "£",
      };
      currency.textContent =
        currencyMap[Shopify.currency.active] ?? Shopify.currency.active;
      price.textContent = Math.ceil(product.pr * Shopify.currency.rate);
    }

    removeButton.dataset.du = product.du;
    removeButton.dataset.empi = product.empi;
    removeButton.dataset.epi = product.epi;

    variantIdInput.value = product.epi;

    let isProductInCart = _swat.platform.isInDeviceCart(product.epi);

    addToCartButton.disabled = isProductInCart;
    addToCartButtonText.textContent = isProductInCart
      ? "Added to cart"
      : "Add to cart";

    return card;
  }
}

customElements.define("cart-sfl", CartSFL);

class PageSFL extends CartSFL {
  constructor() {
    super();
  }

  getCardTemplateToRender() {
    const template = document.createElement("template");
    template.innerHTML = `
        <li class="grid__item sfl-page__card underline-links-hover">
          <remove-from-sfl-button class="sfl-page__remove-button-wrapper">
            <button class="sfl-page__remove-button">
              X
            </button>
          </remove-from-sfl-button>
          <div class="media media--square">
            <img>
          </div>
          <div class="card--standard">
            <div class="card__content">
              <div class="card__information">
                <h3 class="card__heading card__heading--no-after h2">
                  <a class="full-unstyled-link" data-product-title>
                  </a>
                </h3>
                <div class="price">
                  <div class="price__container">
                    <div class="price__regular">
                      <span class="visually-hidden visually-hidden--inline">Regular price</span>
                      <span class="price-item price-item--regular">
                        <span data-product-currency></span><span data-product-price></span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="quick-add">
                <product-form>
                  <form method="post" action="/cart/add" id="" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form">
                    <input type="hidden" name="form_type" value="product">
                    <input type="hidden" name="utf8" value="✓">
                    <input type="hidden" name="id">
                    <button 
                      id="" 
                      type="submit" 
                      name="add"
                      class="quick-add__submit button button--full-width button--secondary"
                    >
                      <span data-sfl-add-to-cart-submit-text>Add to cart</span>
                      <span class="sold-out-message hidden">
                        Sold out
                      </span>
                      <div class="loading__spinner hidden">
                        <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                        </svg>
                      </div>
                    </button>
                  </form>
                </product-form>
              </div>
            </div>
          </div>
        </li>
      `;
    return template;
  }
}

customElements.define("page-sfl", PageSFL);

class SFLWrapper extends TabsComponent {
  constructor() {
    super();
    this.SFLFetchTriggerButton = this.querySelector("[data-sfl-fetch-trigger]");
    this.SFLList =
      this.querySelector("cart-sfl") || this.querySelector("page-sfl");

    if (this.SFLFetchTriggerButton != null && this.SFLList != null) {
      this.SFLFetchTriggerButton.addEventListener(
        "click",
        function () {
          if (this.SFLListHasBeenInitialized == true) return;
          this.SFLList.fetchSFL();
        }.bind(this)
      );
    }

    // Debugging Init & Fetch Buttons {% endcomment %}
    this.initButton = this.querySelector('[data-btn-type="init"]');
    this.fetchButton = this.querySelector('[data-btn-type="fetch"]');

    if (this.initButton != null) {
      this.initButton.addEventListener(
        "click",
        this.initSaveForLater.bind(this)
      );
    }

    if (this.fetchButton != null) {
      this.fetchButton.addEventListener(
        "click",
        function () {
          this.SFLList.fetchSFL();
        }.bind(this)
      );
    }
  }

  initSaveForLater() {
    let onSuccess = function (response) {
      localStorage.setItem("SFLListID", response?.list?.lid);
    };

    console.log("[SFL] Initializing...");

    if (!window.SwymCallbacks) {
      window.SwymCallbacks = [];
    }
    window.SwymCallbacks.push(this.swymCallback.bind(this));
  }

  swymCallback(swat) {
    swat.SaveForLater.init(onSuccess, this.onError);
  }

  showMessage(message, container) {
    const successMessage = document.createElement("sfl-cart-message");
    successMessage.innerHTML = message;

    const SFLMessageContainer = this.querySelector(
      `[data-sfl-message="${container}"]`
    );
    if (SFLMessageContainer != null) {
      SFLMessageContainer.appendChild(successMessage);
    }
  }
}

customElements.define("sfl-wrapper", SFLWrapper);

class ProgressBar extends HTMLElement {
  constructor() {
    super();
    this.promotions = [];
    this.max = 0;
    this.cartTotal = Number.parseInt(this.dataset.cartTotal) / 100;
    this.bar = this.querySelector("[data-bar]");
    this.message = this.querySelector("[data-message]");
    this.promotionsElement = this.querySelector("[data-badges]");
    this.proportion = this.dataset.proportion;
    if (this.dataset.shipscoutEnabled === "true") {
      this.getShipScoutPromotions(); 
    } else {
      this.getThemePromotions();
    }
    this.buildProgressBar();
    this.observeTestSummaryChanges();
  }

  observeTestSummaryChanges() {
    const observer = new MutationObserver((mutationsList) => {
        for (let mutation of mutationsList) {
            if (mutation.attributeName === 'data-test-summary') {
                this.buildProgressBar();
            }
            this.removeDuplicateActiveBadges();
        }
    });
    observer.observe(document.body, { attributes: true, childList: true, subtree: true });
  }
  removeDuplicateActiveBadges() {
      if (!this.promotionsElement) return;
      const activeBadges = this.promotionsElement.querySelectorAll('.progress-bar__badge--active'); 
      if (activeBadges.length > 1) {
          activeBadges[0].remove();
      }
  }
  buildProgressBar() {
    if (this.promotions.length === 0) return;
    this.sortAndSetActivePromotion()
    this.createStepsAndBadges();
    this.createProgressBar();
    this.displayMessage();
  }

  getThemePromotions() {
    const promotions = this.querySelectorAll("[data-promotion]");
    // Create a Promotions Array of all the arrays.
    for (const promotion of promotions) {
      const threshold = Number.parseInt(promotion.dataset.threshold);
      this.promotions.push({
        title: promotion.dataset.title,
        threshold:
          Shopify.currency.active != null
            ? Math.ceil(threshold * Shopify.currency.rate)
            : threshold,
        messageText: promotion.dataset.messageText,
      });
    }
  }

  getShipScoutPromotions() {
    if (window.shipscoutTestObject == null) return;
    this.promotions.push(window.shipscoutTestObject);
  }

  sortAndSetActivePromotion() {
    // Sort Promotions Array in ascending order based on thresholds.
    function compare(a, b) {
      if (a.threshold < b.threshold) {
        return -1;
      }
      if (a.threshold > b.threshold) {
        return 1;
      }
      return 0;
    }
    this.promotions.sort(compare);

    // Find max threshold, find current promotion.
    this.promotions.forEach((promotion) => {
      if (promotion.threshold <= this.cartTotal) {
        promotion.active = true;
      } else {
        promotion.active = false;
        if (this.currentPromotion == null) {
          this.currentPromotion = promotion;
        }
      }
      if (this.max < promotion.threshold) {
        this.max = promotion.threshold;
      }
    });
  }

  displayMessage() {
    const currencyMap = {
      CAD: "$",
      USD: "$",
      AUD: "$",
      BRL: "R$",
      EUR: "€",
      HKD: "$",
      ILS: "₪",
      JPY: "¥",
      MXN: "$",
      NZD: "$",
      NOK: "kr",
      SGD: "$",
      KRW: "₩",
      GBP: "£",
    };

    if (this.currentPromotion != null) {
      this.message.innerHTML = `You're <span class="font-bold"><span class="currency-symbol">${
        currencyMap[Shopify.currency.active] ?? Shopify.currency.active
      }</span>${Math.ceil(
        this.currentPromotion.threshold - this.cartTotal
      )}</span> away from <span class="font-bold">${this.currentPromotion.messageText}</span>`;
    } else {
      this.message.innerHTML = `Congratulations! You've earned <span class="font-bold">${
        this.promotions[this.promotions.length - 1].messageText
      }</span>`;
    }
  }

  createStepsAndBadges() {
    let fragment = document.createDocumentFragment();
    this.promotions.forEach((promotion, i) => {
      if (i != this.promotions.length - 1) {
        const step = document.createElement("div");
        step.classList.add("progress-bar__step");
        const left =
          this.proportion === "equidistant"
            ? ((i + 1) / this.promotions.length) * 100
            : (promotion.threshold / this.max) * 100;
        step.style.left = `${left}%`;
        step.style.transform = "translate(-50%, -50%)";
        this.bar.append(step);
      }

      const promotionBadge = document.createElement("div");
      promotionBadge.classList.add("progress-bar__badge");
      if (promotion.active)
        promotionBadge.classList.add("progress-bar__badge--active");
      promotionBadge.innerHTML = `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g><path class="progress-bar__checkmark-circle" d="M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path><path class="progress-bar__checkmark" d="M15.142 9.98299L10.875 14.25L9.42049 12.7955" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path></g></svg>`;
      const promotionBadgeTitle = document.createElement("div");
      promotionBadgeTitle.innerText = promotion.title;
      promotionBadge.appendChild(promotionBadgeTitle);
      fragment.appendChild(promotionBadge);
    });

    if (this.promotionsElement != null) {
      this.promotionsElement.appendChild(fragment);
    }
  }

  createProgressBar() {
    const innerProgressBar = document.querySelector('.progress-bar__inner-bar') || document.createElement("div");
    innerProgressBar.classList.add("progress-bar__inner-bar");
    let width = 0;
    if (this.proportion === "equidistant") {
      let currentThreshold = 0;
      for (let i = 0; i < this.promotions.length; i++) {
        if (this.promotions[i].active) {
          width += 100 / this.promotions.length;
          currentThreshold = this.promotions[i].threshold;
        } else {
          width +=
            ((this.cartTotal - currentThreshold) /
              (this.promotions[i].threshold - currentThreshold)) *
            (100 / this.promotions.length);
          break;
        }
      }
    } else {
      width = (this.cartTotal / this.max) * 100;
    }
    innerProgressBar.style.width = `${width >= 100 ? 100 : width}%`;
    this.bar.append(innerProgressBar);
  }
}

customElements.define("progress-bar", ProgressBar);

document.addEventListener("DOMContentLoaded", function () {
  const navItems = document.querySelectorAll('[data-open-on-hover]');

  navItems.forEach(item => {
    item.addEventListener('mouseover', function () {
      navItems.forEach(item => item.removeAttribute('open', ''));
      this.setAttribute('open', '');
    })
    item.addEventListener('mouseout', function () {
      navItems.forEach(item => item.removeAttribute('open', ''));
    })
  });
});